export default __webpack_public_path__ + "static/media/login_two.c07ba659.png";